import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core'
import { TopComponent } from './top/top.component'
import { SettingComponent } from './setting/setting.component'
import { ImageComponent } from './image/image.component'
import { ComplianceComponent } from './compliance/compliance.component'
import { CommunicationComponent } from './communication/communication.component'
import { AlignerComponent } from './aligner/aligner.component'
import { ActivatedRoute, ParamMap, Router } from '@angular/router'
import {
    AppConfigService,
    AuthService,
    NotificationService,
    RequestServices,
    RestServices,
    SharedServices,
    SocketService,
} from '@app/services'
import { onsPlatform } from 'ngx-onsenui'
import { environment } from '../../environments/environment'
import { undefinedIsTrue } from '@helpers/common'
import * as moment from 'moment'
import { CookieService } from 'ngx-cookie-service'

declare var PushNotification: any

@Component({
    selector: 'app',
    templateUrl: './client-app.component.html',
    styleUrls: ['./client-app.component.css'],
})
export class ClientAppComponent implements OnInit, AfterViewInit {
    @ViewChild('mobileTabbar') mobileTabbar: ElementRef
    tabHome = TopComponent
    tabSetting = SettingComponent
    tabImage = ImageComponent
    tabCompliance = ComplianceComponent
    tabAligner = AlignerComponent
    tabCommunication = CommunicationComponent
    clientId
    clientInfo
    clientIdParam
    isLoaded = false
    useTreatmentMenu = true
    isAndroid = false
    isMoveToCommunication = false
    isShowChatTab = false
    tabs = [
        'tabHome',
        'tabCompliance',
        'tabAligner',
        'tabImage',
        'tabCommunication',
        'tabSetting',
    ]
    private hasInitPushNotification = false
    private socket: any

    @ViewChild('modalLoading') modalLoading: ElementRef

    constructor(
        private route: ActivatedRoute,
        private authData: AuthService,
        private router: Router,
        private restApi: RestServices,
        private _sharedService: SharedServices,
        private appConfigService: AppConfigService,
        private requestServices: RequestServices,
        private notificationService: NotificationService,
        private socketService: SocketService,
        private cookieService: CookieService,
    ) {
        if (
            this.route.url['value'][3] &&
            this.route.url['value'][3].path == 'click_event' &&
            this.route.url['value'][4] &&
            this.route.url['value'][4].path == 'move_to_page_chat'
        ) {
            this.isMoveToCommunication = true
        }
        this.route.paramMap.subscribe((params: ParamMap) => {
            const id = params.get('id')
            this.clientId = id
            this.clientIdParam = '{"clientId":"' + [this.clientId] + '"}'
        })

        this.requestServices.loadingEmitted$.subscribe((loading) => {
            this.toggleLoading(loading)
        })
        console.log('client app -----------')
    }

    ngAfterViewInit(): void {
        if (this.isMoveToCommunication) {
            setTimeout(() => {
                this.activeTabCommunication(this.mobileTabbar.nativeElement)
                this.isMoveToCommunication = false
            }, 500)
        }

        if (localStorage.getItem("device_token")) {
            this.saveClientDeviceToken(localStorage.getItem("device_token"))
        }
    }

    ngOnInit() {
        this.isAndroid = onsPlatform.isAndroid()
        if (environment.production) {
            if (
                this.route.url['value'][3] &&
                this.route.url['value'][3].path == 'preview' &&
                window.location == window.parent.location
            ) {
                this.router.navigateByUrl('client/preview')
            }
        }
        this.getInfoClient(true)

        const that = this
        this.socket = this.socketService.initSocket()
        this.checkPushNotificationInfo()
        this.socket.on('device_notice', function (data) {
            if (data.clientId === that.authData.getUser().clientId && data.clientDeviceId == that.authData.getUser().clientDeviceId) {
                if (data.deviceRemoved) {

                    let resourceData = {
                        line_code: "client-app.component.ts line 125",
                        reason: "Logout socket, user remove device",
                        token: this.authData.getItem('token'),
                        date: Date.now()
                    }

                    that.authData.authToken().then(tokenReNew => {
                        that.restApi.http_post('account/clientLog', resourceData, tokenReNew).subscribe(res => {
                            console.log('logcat client logout')
                            localStorage.removeItem('user')
                            localStorage.removeItem('token')
                            localStorage.removeItem('timeout')
                            that.cookieService.delete('token')
                            that.router.navigateByUrl('/client/login-token')

                        })
                    })

                }
            }
        })

    }

    activeTab(index, tab) {
        tab.setActiveTab(index)
        this.changePage(index)
    }

    activeTabCommunication(mobileTabbar) {
        mobileTabbar.setActiveTab(4)
        this.changePage(5)
    }

    changePage(index) {
        const arrayChangePage = [
            'changePageMobileApp',
            index,
            this.tabs[index - 1],
        ]
        this._sharedService.emitChange(arrayChangePage)
        // this.getInfoClient()
    }

    getInfoClient(initFlg = false) {
        const resourceUrl = 'resource'
        const resourceData = this.restApi.makeResourceObject({
            status: {
                client: {
                    map: { [this.clientId]: true },
                },
                clientAligner: {
                    searches: { [this.clientIdParam]: true },
                },
                clientVisit: {
                    searches: { [this.clientIdParam]: true },
                },
                clientCompliance: {
                    paths: { [this.clientIdParam]: true },
                },
                clientCommunication: {
                    paths: { [this.clientIdParam]: true },
                },
            },
        })
        this.authData.authToken().then((tokenReNew) => {
            this.restApi
            .http_post(resourceUrl, resourceData, tokenReNew)
            .subscribe((success) => {
                let dataAligener
                let dataClientVisit
                let dataClientCompliance
                let dataClientCommunication
                this.initAppConfig(success['response']['setting'])
                this.clientInfo =
                    success['response']['client']['map'][this.clientId]
                dataAligener =
                    success['response']['clientAligner']['searches'][
                        this.clientIdParam
                        ]
                dataClientVisit =
                    success['response']['clientVisit']['searches'][
                        this.clientIdParam
                        ]
                dataClientCompliance =
                    success['response']['clientCompliance']['paths'][
                        this.clientIdParam
                        ]
                dataClientCommunication =
                    success['response']['clientCommunication']['paths'][
                        this.clientIdParam
                        ]
                this.isLoaded = true
                this.useTreatmentMenu = undefinedIsTrue(
                    this.clientInfo.useTreatmentMenu,
                )
                dataClientCompliance.sort(function(time1, time2) {
                    if (time1.visitDate < time2.visitDate) {
                        return -1
                    } else if (time1.visitDate > time2.visitDate) {
                        return 1
                    } else {
                        return 0
                    }
                })
                this._sharedService.emitChangeParent([
                    this.clientInfo,
                    dataAligener,
                    dataClientVisit,
                    dataClientCompliance,
                    dataClientCommunication,
                ])

            })
        })
    }

    initAppConfig(responseConfig) {
        this.appConfigService.initConfig(responseConfig)
    }

    runTouchMove(event) {
        event.preventDefault()
    }

    private toggleLoading(isShow) {
        if (isShow) {
            this.modalLoading.nativeElement.show()
        } else {
            this.modalLoading.nativeElement.hide()
        }
    }

    private checkPushNotificationInfo() {
        if (this.notificationService.enable) {
            this.hasInitPushNotification = true
            this.notificationService.registerNotification().subscribe(
                async (result) => {
                    if (result) {
                        console.log('deviceToken', result.deviceToken)
                        await this.saveClientDeviceToken(result.deviceToken)
                        this.cookieService.set(
                            'deviceToken',
                            result.deviceToken,
                        )
                    }
                },
                (error) => console.error(error),
            )
        }
        this.notificationService.listenNotification()
        this.notificationService.getNotification$.subscribe(
            (notify) => {
                if (notify) {
                    if (!notify.additionalData['foreground']) {
                        if (!this.isShowChatTab) {
                            this.isShowChatTab = true
                            this.activeTabCommunication(
                                this.mobileTabbar.nativeElement,
                            )
                        }
                        setTimeout(() => {
                            this.isShowChatTab = false
                        }, 5000)
                    }
                }


            },
        )


    }

    private saveClientDeviceToken(token) {
        const resourceUrl = 'resource'
        const updateData = {}
        const platform = window.navigator.userAgent.match(/iOS|iPhone|iPad/)
            ? 'ios'
            : 'android'
        const lastLogin = moment().unix()
        const lang = this.authData.getLang()
        const clientDeviceId = this.authData.getUser().clientDeviceId

        updateData[`deviceToken.${ token }`] = {
            token,
            clientDeviceId,
            platform,
            lastLogin,
            lang,
        }


        const resourceData = {
            actions: [
                {
                    collection: 'client',
                    id: this.clientId,
                    type: 'update',
                    value: updateData,
                },
            ],
            status: {
                client: {
                    map: { [this.clientId]: true },
                },
            },
        }
        return this.authData.authToken().then((tokenReNew) => {
            this.restApi
            .http_post(resourceUrl, resourceData, tokenReNew)
            .subscribe((success) => {
                console.log(success)
            })
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/client-app/client-app.component.ts